import { Injectable } from '@angular/core';
import { IWorkspaceInstanceModel } from '../../../models/workspace/workspace-instance.model';
import { FieldModel } from '../../../models/blueprint/blueprint-field.model';
import { NodeInstanceModel } from '../../../models/node/node-instance.model';
import { IBluePrintNodeModel } from '../../../models/blueprint/blueprint-node.model';
import * as BluePrintConstants from '../../catch-core/data/constants/blueprint.constants';
import { BlueprintStore } from '../../../services/stores/blueprint.store';

export interface BlueprintFieldReferences {
  bugNodeType: IBluePrintNodeModel | null;
  storyNodeType: IBluePrintNodeModel | null;
  epicNodeType: IBluePrintNodeModel | null;
  taskNodeType: IBluePrintNodeModel | null;
  subTaskNodeType: IBluePrintNodeModel | null;
  epicNameField: FieldModel | null;
  extRefField: FieldModel | null;
}

@Injectable({
  providedIn: 'root',
})
export class EditPanelDataHelperService {
  constructor(private blueprintStore: BlueprintStore) {}

  public buildFormData(fieldList: FieldModel[] = [], node: NodeInstanceModel | null | undefined): Record<string, any> {
    const formData: Record<string, any> = {};
    if (!Array.isArray(fieldList) || !node?.fields) {
      return formData;
    }

    fieldList.forEach((field) => {
      if (!field) return;
      const fieldId = field.id;
      const existingValue = node.fields[fieldId] ?? '';
      const normalizedTypeLower = (field.fieldType || '').toLowerCase().replace('blueprintfield', '');
      if (normalizedTypeLower === 'datetime' || normalizedTypeLower === 'date') {
        const newDate = new Date(existingValue);
        formData[fieldId] = isNaN(newDate.getTime()) ? '' : newDate;
      } else if (normalizedTypeLower === 'checkbox') {
        formData[fieldId] = existingValue === 'true' || existingValue === true;
      } else if (normalizedTypeLower === 'dropdownmultiple') {
        if (typeof existingValue === 'string' && existingValue.trim() !== '') {
          formData[fieldId] = existingValue.split('\n');
        } else if (Array.isArray(existingValue)) {
          formData[fieldId] = existingValue;
        } else {
          formData[fieldId] = [];
        }
      } else {
        formData[fieldId] = existingValue;
      }
    });

    return formData;
  }

  public loadBlueprintFieldReferences(workspace: IWorkspaceInstanceModel | null | undefined): BlueprintFieldReferences {
    const blueprint = this.blueprintStore.getBlueprintByIdFromCache(workspace?.bluePrintId);
    const nodes = blueprint?.nodes ?? [];
    const fields = blueprint?.fields ?? [];
    return {
      bugNodeType: nodes.find((node) => node.name.toLocaleLowerCase() === BluePrintConstants.BUG_NODE_LOWER) || null,
      storyNodeType: nodes.find((node) => node.name.toLocaleLowerCase() === BluePrintConstants.STORY_NODE_LOWER) || null,
      epicNodeType: nodes.find((node) => node.name.toLocaleLowerCase() === BluePrintConstants.EPIC_NODE_LOWER) || null,
      taskNodeType: nodes.find((node) => node.name.toLocaleLowerCase() === BluePrintConstants.TASK_NODE_LOWER) || null,
      subTaskNodeType: nodes.find((node) => node.name.toLocaleLowerCase() === BluePrintConstants.SUB_TASK_NODE_LOWER) || null,
      epicNameField: fields.find((field) => field.name.toLocaleLowerCase() === BluePrintConstants.EPIC_NAME_FIELD_LOWER) || null,
      extRefField: fields.find((field) => field.name.toLocaleLowerCase() === BluePrintConstants.EXT_APP_REFERENCE_ID_FIELD) || null,
    };
  }
}
